import { useState } from "react";
import "./Presurvey.css";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as solidStar } from "@fortawesome/free-solid-svg-icons";
import { faStar as regularStar } from "@fortawesome/free-regular-svg-icons";

export const DocPresurvey = ({
  setPreSurvey,
  setTermsAndConditionCheck,
  setFormData,
}) => {
  const [form, setForm] = useState({
    s1: "",
    s2: 0,
    s4: "",
    s5: "",
  });
  const [selectedOptions, setSelectedOptions] = useState([]);

  const options = [
    { id: "s5op-1", label: "ASQ‑3", value: "ASQ‑3" },
    { id: "s5op-2", label: "TDSC", value: "TDSC" },
    { id: "s5op-3", label: "WHO", value: "WHO" },
    { id: "s5op-4", label: "Own", value: "Own" },
    { id: "s5op-5", label: "None", value: "None" },
    { id: "s5op-6", label: "Other", value: "Other" },
  ];

  const S4options = [1, 2, 3, 4, 5];


  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    console.log("checked ", checked);
    setSelectedOptions(
      (prev) =>
        checked
          ? [...prev, value] // add on check
          : prev.filter((val) => val !== value) // remove on uncheck
    );
  };

  function handleChange(e) {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  }
  const getCommaSeparated = () => selectedOptions.join(", ");
  const optionlength = selectedOptions.length > 0;

  function handleSubmit(e) {
    e.preventDefault();
    const validateFields = Object.values({
      s1: form.s1,
      s2: form.s2,
      s3: optionlength ? getCommaSeparated() : "",
      s4: form.s4,
      s5: form.s5,
    }).every((val) => val);
    if (!validateFields) {
      toast.warn("Please answer all questions");
      return;
    }
    console.log({s1: form.s1,
        s2: form.s2,
        s3: optionlength ? getCommaSeparated() : "",
        s4: form.s4,
        s5: form.s5,});
    setFormData((prev) => ({
      ...prev,
      s1: form.s1,
      s2: form.s2,
      s3: optionlength ? getCommaSeparated() : "",
      s4: form.s4,
      s5: form.s5,
    }));

    setPreSurvey(false);
  }
  return (
    <form className="presurvey" onSubmit={handleSubmit}>
      <p>Baseline-Survey</p>
      <div className="survey-container">
        <p>Please complete below and click continue Sign-up</p>
        <div className="survey-questiondiv survey-s6">
          <label htmlFor="s1">
            1. Minutes spent on developmental checks per visit
          </label>
          <input
            className="survey-input"
            type="number"
            id="s1"
            name="s1"
            value={form.s1}
            onChange={handleChange}
          />
        </div>
        <div className="survey-questiondiv survey-s6">
          <label htmlFor="s2">
            2. Number of formal screenings in last 10 visits
          </label>
          <input
            className="survey-range"
            type="range"
            value={form.s2}
            min={0}
            max={10}
            name="s2"
            id="s2"
            step={1}
            list="s2-ticks"
            onChange={handleChange}
          />
          <datalist id="s2-ticks">
            {Array.from({ length: 11 }, (_, i) => (
              <option key={i} value={i} />
            ))}
          </datalist>
          <div className="tick-labels">
            {Array.from({ length: 11 }, (_, i) => (
              <span key={i}>{i}</span>
            ))}
          </div>
        </div>

        <div className="survey-questiondiv">
          <label htmlFor="options">3. Tools used (tick)</label>
          <div className="survey-options">
            {options.map((opt) => (
              <div key={opt.id} className="survey-option">
                <label htmlFor={opt.id}>
                  <input
                    type="checkbox"
                    id={opt.id}
                    name="options"
                    value={opt.value}
                    checked={selectedOptions.includes(opt.value)}
                    onChange={handleCheckboxChange}
                  />
                  {opt.label}
                </label>
              </div>
            ))}
          </div>
        </div>
        <div className="survey-questiondiv">
          <label htmlFor="s4">4. Confidence catching delays</label>
          <div className="star-rating">
            {S4options.map((val) => (
              <span
                key={val}
                onClick={() =>
                  handleChange({
                    target: { name: "s4", value: val.toString() },
                  })
                }
                style={{ cursor: "pointer" }}
              >
                <FontAwesomeIcon
                  icon={form.s4 >= val ? solidStar : regularStar}
                  style={{
                    color: "#f5b301",
                    fontSize: "24px",
                    marginRight: "4px",
                  }}
                />
              </span>
            ))}
          </div>
        </div>
        <div className="survey-questiondiv survey-s6">
          <label htmlFor="s5">5. Biggest pain-point (≤50 words)</label>
          <textarea name="s5" id="s5" onChange={handleChange}></textarea>
        </div>
      <div className="survey-btns">
        <button type="submit">Continue Sign-up</button>
        <button
          type="button"
          onClick={() => {
            setPreSurvey(false);
            setTermsAndConditionCheck(false);
          }}
        >
          cancel
        </button>
      </div>
      </div>
    </form>
  );
};
